module.exports = __webpack_public_path__ + "img/logo.bcc273f6.png";